import React, { useState } from 'react';
import { Card, type CardProps } from '../Card';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';
import { CardLoadingContext } from './LoadingContext';
import './LoadingCard.scss'; // Make sure the styles are imported

interface LoadingCardProps extends CardProps {
  children: React.ReactNode;
  spinner?: React.ReactNode;
  className?: string;
}

export const LoadingCard: React.FC<LoadingCardProps> = ({
  children,
  spinner,
  className,
  ...cardProps
}) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <CardLoadingContext.Provider value={{ setLoading }}>
        <Card
          {...cardProps}
          className={clsx(
            className,
            'TPH_card'
          )}
        >
          {children}
          {isLoading && (
            <div className="loadingcard-overlay" data-testid="loading-overlay">
            {spinner || <CircularProgress />}
          </div>
        )}
        </Card>

    </CardLoadingContext.Provider>
  );
};